import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
//import { filtrationcontext } from "../../../../context/Filtercontext";
import trans from "../../../../utils";
import { Checkbox } from "antd";

export default function ObjectTableHead({ type }) {
	let { pathname } = useLocation();
	//const { Sort, setSort } = useContext(filtrationcontext);
	/*useEffect(() => {
    if (
      (Sort.type === "" && Sort.value === null) ||
      (Sort.type === "id" && Sort.value === null)
    ) {
      setSort({ type: "last update", value: true });
    }
  }, [Sort.type, Sort.value, setSort]);
  useEffect(() => {
    return () => setSort({ type: "id", value: null });
  }, [setSort]);
  const Sorting = (type) => {
    setSort((prevSort) => ({
      type: type,
      value: !prevSort.value,
    }));
  };*/
	const lang = localStorage.getItem("lang") || "en";
	const [tableHeaders, setTableHeaders] = useState([
		"Vehicle name",
		"Speed",
		"last update",
		"status",
		"Actions",
	]);
	useEffect(() => {
		if (type === "vehicle") {
			setTableHeaders([
				"Vehicle name",
				"Speed",
				"last update",
				"status",
				"Actions",
			]);
		} else if (type === "mobility") {
			setTableHeaders([
				"Device name",
				"assignment to",
				"last update",
				"status",
				"Actions",
			]);
		}
	}, [type]);
	return (
		<>
			<div className="object-table">
				{/** <div className={`${lang === "en" ? "mr-16" : "ml-16"}`}>
          <Checkbox /> 
      </div>*/}
				{pathname === "/livetracking" ? (
					<>
						{tableHeaders?.map((header, index) => (
							<div
								className="fs-14 fw-600 object-table-element d-flex cursor"
								key={index}
							>
								<div>{trans(header)}</div>
							</div>
						))}
					</>
				) : (
					<>
						<div className="fs-14 fw-600 object-table-element w-50">
							{trans("Geofence Name")}
						</div>
						<div className="fs-14 fw-600 object-table-element">
							{trans("Actions")}
						</div>
					</>
				)}
			</div>
		</>
	);
}
